import React, { useState, useEffect } from "react"
import _ from "lodash"

import NoneStateTrashIcon from "components/table/carousel/none-state-trash-icon"
import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NamedItemInput, NumberInput } from "components/table/carousel/inputs"
import { RentBasic_s } from "components/multifamily/rent-roll/rent-roll-styles"
import { field_attrs } from "components/table/lib/column-field"

const RentBasic = (props: {rowData: [], field: string, defaults: {}, namedItems: {}, persist: Function}) => {
  const emptyRecord = {
    occupiedAmtType: null,
    occupiedAmt: null,
    occupiedInflationNamedItemId: null,
    marketAmtType: null,
    marketAmt: null,
    marketInflationNamedItemId: null
  }
  const [data, setData] = useState<object|null>(props.rowData[props.field]);

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val
    if (!nextData['occupiedAmtType']) nextData['occupiedAmtType'] = props.defaults['rentAmtType']
    if (!nextData['marketAmtType']) nextData['marketAmtType'] = props.defaults['rentAmtType']
    if (!nextData['occupiedInflationNamedItemId'] && props.defaults['rentInflation']){
      nextData['occupiedInflationNamedItemId'] = props.defaults['rentInflation']['inflationNamedItemId']
    }
    if (!nextData['marketInflationNamedItemId'] && props.defaults['rentInflation']){
      nextData['marketInflationNamedItemId'] = props.defaults['rentInflation']['inflationNamedItemId']
    }
    setData(nextData)
    props.persist({...nextData, state: 'basic'}, 'rentdetail', props.rowData)
  }

  const attrs = (field) => field_attrs('multifamily', props.field)(field)(props.rowData, props)

  return (
    <RentBasic_s>
      <NoneStateTrashIcon />
      <SingleRowCarouselState_s>
        <div></div>
        <label>Amount</label>
        <label>Amt Type</label>
        <label>Inflation</label>
      </SingleRowCarouselState_s>
      <SingleRowCarouselState_s>
        <div>
          <label>Occupied:</label>
        </div>
        <div>
          <NumberInput className="automated" data={data} attrs={attrs} field="occupiedAmt" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
        <div>
          <DropdownInput className="automated" data={data} attrs={attrs} field="occupiedAmtType" options={['/Area/Mo', '/Area/Yr', '/Unit/Mo', '/Unit/Yr']} persist={updateData} default={props.defaults['rentAmtType']} />
        </div>
        <div>
          <NamedItemInput className="automated" data={data} attrs={attrs} field="occupiedInflationNamedItemId" options={props.namedItems['inflation']} persist={updateData} default={props.defaults['rentInflation'] && props.defaults['rentInflation']['inflationNamedItemId']} namedItem="inflationNamedItemId" />
        </div>
      </SingleRowCarouselState_s>
      <SingleRowCarouselState_s>
        <div>
          <label>Market:</label>
        </div>
        <div>
          <NumberInput className="automated" data={data} attrs={attrs} field="marketAmt" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
        <div>
          <DropdownInput className="automated" data={data} attrs={attrs} field="marketAmtType" options={['/Area/Mo', '/Area/Yr', '/Unit/Mo', '/Unit/Yr']} persist={updateData} default={props.defaults['rentAmtType']} />
        </div>
        <div>
          <NamedItemInput className="automated" data={data} attrs={attrs} field="marketInflationNamedItemId" options={props.namedItems['inflation']} persist={updateData} default={props.defaults['rentInflation'] && props.defaults['rentInflation']['inflationNamedItemId']} namedItem="inflationNamedItemId" />
        </div>
      </SingleRowCarouselState_s>
    </RentBasic_s>
  )
}

export default RentBasic